<div class="swatches">
    @for (pair of swatches | keyvalue; track pair) {
        <div class="swatch" [class.active]="value === pair.key" (click)="writeValue(pair.key)">
            <div [style.background]="pair.value"></div>
        </div>
    }
</div>
